export default __webpack_public_path__ + "static/media/tutrial2.e16ebce1.jpg";